import React from "react";
import {Button, Columns, Heading, Modal, Section, Form} from "react-bulma-components";
import {readableDate} from "../../utils";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";



export default function ConfirmModal({onConfirm, movement, show, setShow, onTrackingOptionChange, trackingOptions, onChange}){



    const validator = (movement) => {
        if(!!movement.tracking_option){
            return true
        }
        return false
    }

    return (
        <Modal
            closeOnBlur
            show={show}
            onClose={() => setShow(false)}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{ backgroundColor: "white" }}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Complete Movement</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Movement Number</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.id}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Department Creator</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.department ? movement.department.name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Vehicle To Move</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.vehicle}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Start Address</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.start_address}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>End Address</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.end_address}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Delivery Date</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={readableDate(movement.delivery_date)}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Miles</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.miles}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Rate</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.movement_rate ? movement.movement_rate.name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Customer Cost</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.cost}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Department Charger</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.movement_performer ? movement.movement_performer.name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Vehicle User For Movement</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.vehicle_used ? movement.vehicle_used.registration : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Type</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.movement_type ? movement.movement_type.name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Driver</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.driver ? movement.driver.name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Internal Charge</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={movement.internal_charge}
                            />
                        </Columns.Column>

                        <Columns.Column/>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <TrackingOptionsPicker
                                name={"tracking_option"}
                                options={trackingOptions}
                                editable={true}
                                label={"Tracking Option"}
                                value={movement.tracking_option}
                                onChange={onTrackingOptionChange}
                                disabled={false}
                                inlineEdit={false}
                                blank={true}
                                className={"y"}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                onClick={() => onConfirm(movement)}
                                fullwidth={true}
                                disabled={!validator(movement)}
                            >
                                Complete
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"danger"}
                                fullwidth={true}
                                onClick={() => setShow(false)}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )
}